import { mutator } from 'satcheljs';
import {
    type RESET_SELECTIONActionMessage,
    resetSelectionOnTable,
} from 'owa-mail-actions/lib/mailListSelectionActions';
import resetExpansionViewStateInternal from 'owa-mail-list-store/lib/utils/resetExpansionViewStateInternal';

const defaultExport: (actionMessage: RESET_SELECTIONActionMessage) => void = mutator(
    resetSelectionOnTable,
    actionMessage => {
        const tableView = actionMessage.tableView;
        tableView.selectedRowKeys.clear();
        tableView.isInCheckedMode = false;
        tableView.isOnlyOptimisticallyInCheckedMode = false;
        resetExpansionViewStateInternal();
    }
);
export default defaultExport;
